import * as localService from './localService';
import { isFeatureEnabled } from 'owa-feature-flags';
import type { OutlookSpacesService } from 'owa-timestream-types';
import OutlookSpacesOwsClient from './OutlookSpacesOwsClient';

// Cache this when we use the first Spaces network request
// so we don't mix local and OWS services in the same session.
let service: OutlookSpacesService | undefined = undefined;

// NOTE: this function is being provided to keep current code happy while
// we transition to a per-project service. In other words, do not add more
// usage of it, since code using this function is basically saying it does
// not understand group or additional user mailboxes. The preference is to
// use owa-timestream-store/lib/service, which takes ProjectId and knows
// which service (ie, mailbox) to use to talk to such project.
export default function getDefaultOutlookSpacesService() {
    if (service === undefined) {
        service = isFeatureEnabled('cal-board-dev-useLocalService')
            ? localService
            : new OutlookSpacesOwsClient();
    }
    return service!;
}
